export default {
  home: "홈",
  news: "최신 정보",
  community: "커뮤니티",
  character: "캐릭터",
  world: "세계관",
  features: "게임 소개",
  topUp: "충전",
  customerService: "고객센터",
  download: "다운로드",
  moreDownload: "더 보기",
  screenshot: "스크린샷",
  video: "동영상",
  poster: "포스터",
  downloadGame: "다운로드",
  scan: "QR코드를 스캔하세요",
  prev: "이전",
  next: "다음",
  moreNews: "더 보기",
  latest: "최신",
  fwtk: "서비스 약관",
  yszc: "개인정보 취급 방침",
  noContent: "준비 중",
  goPay: "이동",
  payGuide: "확인",
  stayTurn: "준비 중",
  back: "돌아가기",
  huoyi: "불개미",
  huoyi_text:
    "불개미는 세계에서 가장 악명 높은 침입종 중 하나이며, 아마도 모든 개미 중 가장 두려움을 주는 종일 것입니다. 비록 그들의 몸집은 보통 4-6mm 정도로 작지만, 그들이 일으키는 파괴는 의심할 여지없이 엄청납니다.",
  huoyi_skill1: "전술 필살기",
  huoyi_skill2: "질풍 병정개미 생명",
  huoyi_skill3: "질풍 병정개미 방어",
  huoyi_skill4: "질풍 병정개미 공격",
  ciyi: "등색 가시개미",
  ciyi_text:
    "등색 가시개미는 호주의 개활지 유칼립투스 숲과 열대 초원 숲에서 흔히 발견되며, 등에는 황금색에서 등색으로 그라데이션을 이루는 부드러운 솜털이 덮여 있습니다. 가장자리에는 대칭을 이루는 가시 모양의 껍질이 돌출되어 있는데, 외골격이 단단해 외부의 적을 물리치는 무기가 됩니다.",
  ciyi_skill1: "전술 필살기",
  ciyi_skill2: "원거리 병정개미 생명",
  ciyi_skill3: "원거리 병정개미 방어",
  ciyi_skill4: "원거리 병정개미 공격",
  hongyi: "검붉은 개미",
  hongyi_text:
    "현재까지 이 신비한 종에 대한 정확한 학명이 정해지지 않았다. 길이는 8밀리미터 정도로 등에 눈에 띄는 혈점을 갖고 있습니다.",
  hongyi_skill1: "연구 속도",
  hongyi_skill2: "훈련 속도",
  hongyi_skill3: "부대 규모 상한",
  jinjia: "하베스터",
  jinjia_text:
    "남아메리카 북부의 아마존 열대우림에서 발견된 육식성 개미입니다. 이 개미들의 크기는 일개미와 병정개미에 따라 다른데, 병정개미의 크기는 15-17mm에 달합니다. 먹이는 매우 다양해서 각종 곤충부터 작은 달팽이까지 먹습니다. 강력한 이빨로 먹이를 찢어 먹을 뿐만 아니라, 침과 독으로 먹이를 더 잘 분해할 수 있습니다.",
  jinjia_skill1: "전술 필살기",
  jinjia_skill2: "근위 병정개미 생명",
  jinjia_skill3: "근위 병정개미 방어",
  jinjia_skill4: "근위 병정개미 공격",
  gongbei: "목수 개미",
  gongbei_text:
    "목수 개미는 남아메리카 북부의 일부 지역에만 분포하며, 아마존 열대우림의 유령으로 불립니다.목수 개미의 주된 먹이는 대나무 마디 안에서 기르는 진딧물에서 감로를 채집하는 것이지만, 가끔 다른 곤충도 잡아먹습니다.",
  gongbei_skill1: "훈련 속도",
  gongbei_skill2: "훈련 먹이 감소",
  gongbei_skill3: "체력 소모 감소",
  specialAnt: "특종개미",
};
